module.exports = __webpack_public_path__ + "img/img51.2b5fcf7e.png";